import React from 'react'
import AddNewTechnical from './AddNewTechnical'
import AddBreadCrumb from './AddBreadCrumb';
function AddTechnicalPage() {
    return ( 
        <div className = "container-fluid">
        <AddBreadCrumb />
        <AddNewTechnical />
        </div>
     );
}

export default AddTechnicalPage;